<template>
  <!-- component -->
  <div class="overflow-x-auto">
    <div
      class="min-w-screen w-full flex items-center justify-center bg-gray-100 font-sans overflow-hidden"
    >
      <div class="w-full lg:w-5/6">
        <div class="bg-white shadow-md rounded my-6">
          <table class="min-w-max w-full table-auto">
            <thead>
              <tr
                class="bg-gray-200 text-gray-600 uppercase text-sm leading-normal"
              >
                <th class="py-3 px-6 text-left">Wallet Name</th>
                <th class="py-3 px-6 text-left">User Name</th>
                <th class="py-3 px-6 text-center">Amount</th>
                <th class="py-3 px-6 text-center">Status</th>
                <th class="py-3 px-6 text-center">Actions</th>
              </tr>
            </thead>
            <ListTransactionsDetails></ListTransactionsDetails>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListTransactionsDetails from '@/components/ListTransactionDetails'
import { mapState } from 'vuex'
export default {
  name: "FinanceDetails",
  components: {
    ListTransactionsDetails
  },
  computed: {
    ...mapState(['financesDetails'])
  },
};
</script>

<style>
</style>